import { useToggle } from '@hooks/useToggle';
import { INSERT_HORIZONTAL_RULE_COMMAND } from '@lexical/react/LexicalHorizontalRuleNode';
import { LexicalEditor } from 'lexical';
import { Popover, PopoverBody } from 'reactstrap';
import { TOOLBAR_POPOVER_PROPS } from './StylePlugin/utils';
import { ToolbarIconButton } from './ToolbarIconButton';
import { SimpleTooltip } from '@g17eco/molecules/simple-tooltip';

const INSERT_DROPDOWN_ID = 'insert-dropdown';
export const InsertDropdown = ({ editor }: { editor: LexicalEditor }) => {
  const [popoverOpen, toggle] = useToggle(false);

  const insertHorizontalRule = () => {
    editor.dispatchCommand(INSERT_HORIZONTAL_RULE_COMMAND, undefined);
    toggle();
  };

  return (
    <SimpleTooltip text={'Insert'}>
      <ToolbarIconButton
        id={INSERT_DROPDOWN_ID}
        icon='fal fa-plus'
        onClick={toggle}
        isActive={popoverOpen}
        caret
      />
      <Popover {...TOOLBAR_POPOVER_PROPS} isOpen={popoverOpen} toggle={toggle} target={INSERT_DROPDOWN_ID}>
        <PopoverBody className='editor__toolbar__submenu p-1'>
          <ToolbarIconButton
            testId='toolbar-horizontal-rule'
            icon='fa-square-half-stroke-horizontal'
            onClick={insertHorizontalRule}
            isActive={false}
            title='Horizontal rule'
          />
        </PopoverBody>
      </Popover>
    </SimpleTooltip>
  );
};
